import { render, staticRenderFns } from "./InputRadioButton.vue?vue&type=template&id=aaebc606"
import script from "./InputRadioButton.vue?vue&type=script&lang=js"
export * from "./InputRadioButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports